module.exports = __webpack_public_path__ + "static/media/bannerMain.46097e40.jpg";